import { FC, ReactNode } from "react";
import { CircularProgress } from "@mui/material";

const LoadingWrapper: FC<{
  style?: React.CSSProperties;
  children: ReactNode;
  loading: boolean;
  transparent?: boolean;
}> = ({ children, loading = false, transparent = false, style }) => {
  if (!loading) {
    return <>{children}</>;
  }

  return (
    <div className={"relative"}>
      <div className={"pointer-events-auto"}>{children}</div>

      <div
        style={{ ...style }}
        className={`absolute flex items-center justify-center gap-2 inset-0 ${!transparent ? "bg-white/50" : "bg-white/40"} `}
      >
        <CircularProgress />
      </div>
    </div>
  );
};
export default LoadingWrapper;
